import React from "react";
import { IProductDetail } from "../../interfaces/shopify";
import { CardMedia, Grid, Typography, useTheme } from "@mui/material";

type ImageDetailProps = {
  data: IProductDetail | null | undefined;
  dataTitle: IProductDetail | null | undefined;
};
export const ImageDetail = ({ data, dataTitle }: ImageDetailProps) => {
  const theme = useTheme();

  return (
    <React.Fragment>
      <Grid spacing={{xs: 2, md: 3}} container>
        {dataTitle?.titleDetail?.references.edges.map((t, i) => (
          <Grid
          key={i}
            mb={5}
            display="flex"
            gap={1}
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            size={12}
          >
            <Typography
              sx={{
                fontSize: {xs: 25, sm: 30, md: 35},
                fontWeight: 800,
                textAlign: "center",
                background: `linear-gradient(50deg, ${theme.palette.secondary[900]} , ${theme.palette.secondary[300]} 70%)`,
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              {t.node.fields[1].value}
            </Typography>
            <Typography
              maxWidth={1000}
              textAlign="center"
              variant="body2"
              fontSize={{xs: 12, md: 14}}
              lineHeight={1.6}
              sx={{ color: theme.palette.text.disabled, textWrap: "pretty" }}
            >
              {t.node.fields[0].value}
            </Typography>
          </Grid>
        ))}

        {data?.fileDetail?.references.edges.map((d, i) => (
          <Grid key={i} size={6}>
            <CardMedia
              sx={{ height: { xs: 200, md: "80svh" }, borderRadius: 1 }}
              component="img"
              image={d.node.fields[0].reference?.image.url}
              alt={d.node.fields[0].reference?.image.altText}
            />
          </Grid>
        ))}
      </Grid>
    </React.Fragment>
  );
};
